export enum ComplaintStatus {
  /**
   * 处理中
   */
  WAIT_DEAL = 0,

  /**
   * 已驳回
   */
  REJECT = 1,

  /**
   * 已违约
   */
  DEFALUTED = 2,

  /**
   * 未违约
   */
  NO_DEFALUTED = 3
}

export const ComplaintStatusMemberTextMap = {
  [ComplaintStatus.WAIT_DEAL]: '处理中',
  [ComplaintStatus.REJECT]: '已驳回',
  [ComplaintStatus.DEFALUTED]: '已违约',
  [ComplaintStatus.NO_DEFALUTED]: '未违约'
}
export const ComplaintStatusColorMap = {
  [ComplaintStatus.WAIT_DEAL]: 'blue',
  [ComplaintStatus.REJECT]: 'orange',
  [ComplaintStatus.DEFALUTED]: 'volcano',
  [ComplaintStatus.NO_DEFALUTED]: 'green'
}
export const ComplaintStatusOperationTextMap = {
  [ComplaintStatus.WAIT_DEAL]: '待处理',
  [ComplaintStatus.REJECT]: '已驳回',
  [ComplaintStatus.DEFALUTED]: '已违约',
  [ComplaintStatus.NO_DEFALUTED]: '未违约'
}
